var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout-header" }, [
    _c("div", { staticClass: "layout-title" }, [
      _vm._v(" " + _vm._s(_vm.headerTitle) + " "),
    ]),
    _c("div", { staticClass: "layout-header-actions" }, [
      _c(
        "div",
        { staticClass: "layout-header-action" },
        [
          _c("c-button-2", {
            attrs: {
              size: "small",
              label: _vm.createNewTypeLabel,
              icon: {
                icon: "plus",
                color: "blue",
              },
            },
            on: { click: _vm.createNewTypeAction },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "layout-header-action" },
        [
          _c("c-button-2", {
            attrs: {
              size: "small",
              label: _vm.createNewItemLabel,
              icon: {
                icon: "plus",
                color: "blue",
              },
            },
            on: { click: _vm.createNewItemAction },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }